import * as React from 'react';
import { themr } from 'react-css-themr';
const DumpAttributeItems = ({ attributes, theme = {}, }) => {
    return (React.createElement("dl", { className: theme.root }, (attributes || []).map((item, idx) => (React.createElement(React.Fragment, { key: idx },
        React.createElement("dt", { className: theme.label }, item.label),
        React.createElement("dd", { className: theme.value }, item.value))))));
};
const AttributeItems = themr('AttributeItems', {}, {
    composeTheme: 'softly',
})(DumpAttributeItems);
export default AttributeItems;
//# sourceMappingURL=index.js.map